import { createFileRoute } from "@tanstack/react-router";
import { Step5ReviewInformation } from "@/features/vendor/onboarding/v1/step-5-review-information";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-5-review-information",
)({
  component: Step5ReviewInformation,
});
